module.exports = __webpack_public_path__ + "static/logos-tiles-dpr-50c041ae1847a8be67b9a4f395adeb94.svg";